import {
  FETCH_LIVE_WELD_STATUS_SUCCESS,
  FETCH_LIVE_WELD_STATUS_FAILURE,
  START_WELD_STATUS_LOADER,
  CHANGE_WELD_NUMBER,
  CHANGE_WELD_NUMBER_WITH_UID,
} from "./types";

const initialState = {
  weldStatusList: [],
  isWeldStatusLoading: false,
  error: null,
  isWeldNumberChanging: false,
  isWeldNumberWithUidChanging: false,
  weldParameterErrors: null,
};

const data360LiveSlogReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_WELD_STATUS_LOADER:
      return {
        ...state,
        isWeldStatusLoading: true,
        error: null,
      };
    case FETCH_LIVE_WELD_STATUS_SUCCESS:
      return {
        ...state,
        weldStatusList: action.payload.data,
        weldParameterErrors: action.payload.weldParameterErrors,
        isWeldStatusLoading: false,
        error: null,
      };
    case FETCH_LIVE_WELD_STATUS_FAILURE:
      return {
        ...state,
        isWeldStatusLoading: false,
        error: action.payload,
        weldParameterErrors: null,
      };
    case CHANGE_WELD_NUMBER:
      return {
        ...state,
        isWeldNumberChanging: true,
      };
    case CHANGE_WELD_NUMBER_WITH_UID:
      return {
        ...state,
        isWeldNumberWithUidChanging: true,
      };
    default:
      return state;
  }
};

export default data360LiveSlogReducer;
